import { Avatar, Box, Card, CardContent, Typography } from "@material-ui/core"
import { Email, Person, Phone } from "@material-ui/icons"

const CustomerCard=(props)=>{
    const {name, contact} = props;
    return (
        <Card sx={{p:2, maxWidth:350, boxShadow: 3, borderRadius:2}}>
            <CardContent>
                <Box display="flex" alignItems="center" gap={1}>
                    <Person color="action" />
                    <Typography variant="subtitle1" fontWeight="bold">
                        {"بيانات العميل"}
                    </Typography>
                </Box>
                <Box display="flex" flexDirection={"column"} alignItems={"center"} mt={2}>
                    <Avatar sx={{width:60, height:60, backgroundColor: "#e0f2fa"}}>

                    </Avatar>
                    <Typography variant="h6" fontWeight="bold" mt={1}>
                        {name}
                    </Typography>
                    {/* <Typography variant="body2" fontWeight="textSecondary" >
                        3 orders
                    </Typography> */}
                </Box>
                <Box display="flex"  alignItems="center" mt={2} gap={1}>
                    <Phone color="action" />
                    <Typography variant="body2">{contact}</Typography>
                </Box>

                <Box display="flex"  alignItems="center" mt={1} gap={1}>
                    <Email color="action" />
                    <Typography variant="body2">{}</Typography>
                </Box>
            </CardContent>
        </Card>
    )
}

export default CustomerCard;